function __log(){
    if(!!window.DEBUG_MODE) {
        console.log.apply(this, arguments);
    }
}
DEBUG_MODE = true;
//URL_BLACKBOX = window.is_stripe_live ? "https://blackbox.tiptoque.com" : "https://blackbox-preprod.tiptoque.com";
URL_BLACKBOX = window.Shopify["theme"]["role"] != "unpublished" ? "https://blackbox.tiptoque.com" : "https://blackbox-preprod.tiptoque.com";

function createStripeSetupIntent() {
    __log('Création de l intention de paiement')
    var $d = $.Deferred();

    $.get(URL_BLACKBOX+'/payments/stripe/create_intents?token=1234')
        .then(function(res){
            __log('Intention de setup créée', res)
            localStorage.setItem('tt_pisecrets', res.secret);
            $d.resolve(res);
        })
    return $d;
}


function instantiateStripeDeposit() {
    var $d = $.Deferred();
    var stripe = window.__stripe_instance;
    if(!!localStorage.getItem('tt_pisecrets')) {
        __log('On a déjà récupéré des infos sur ce client');
        stripe.retrievePaymentIntent(localStorage.getItem('tt_pisecrets')).then(function(res){
            /*
            Status of this PaymentIntent, one of requires_payment_method, requires_confirmation, requires_action, processing, requires_capture, canceled, or succeeded
            */
            if(!!res.error) {
                __log('Souci sur le payment intent, reset et reload', res.error);
                localStorage.removeItem('tt_pisecrets');
                $d = instantiateStripeDeposit();
            }
            __log('La caution a pour statut ', res.paymentIntent.status);
            if(res.paymentIntent) {
                if(res.paymentIntent.status !== 'succeeded') {
                    __log('On a une intention qui existe mais qui n\'est pas valide');
                    instantiateStripeCardForm(stripe, res.paymentIntent.client_secret).then($d.resolve, $d.reject);

                } else {
                    __log('On a bien les infos bancaires');
                    CartJS.setAttribute('stripe_deposit', res.paymentIntent.payment_method, {
                        success: $d.resolve
                    });
                }
            } else {
                __log('C\'est expiré, on redemande');
                createStripeSetupIntent(stripe).then(function(res){
                    instantiateStripeCardForm(stripe, res.setupIntent.client_secret).then($d.resolve, $d.reject);
                }, $d.reject);
            }
        }, function () {
            localStorage.removeItem('tt_pisecrets');
            $d = instantiateStripeDeposit();
        })
    } else {
        __log('Il n y a pas d\'info validée dans les cookies');
        createStripeSetupIntent(stripe).then(function(res){
            instantiateStripeCardForm(stripe, res.secret).then($d.resolve, $d.reject)
        });
    }
    return $d;
}

function onStripeFormOutcome(result) {
    var successElement = document.querySelector('.success');
    var errorElement = document.querySelector('.error');
    successElement.classList.remove('visible');
    errorElement.classList.remove('visible');
    if (result.token) {
        successElement.querySelector('.token').textContent = result.token.id;
        successElement.classList.add('visible');
    } else if (result.error) {
        errorElement.innerHTML = 'Oups, il y a un malentendu entre notre cocotte et votre carte. Utilisez <a href="' + window.stripeTypeformURL + '" target="_blank">ce formulaire</a> pour nous aider à trouver une solution. Signé le Gang.';
        errorElement.classList.add('visible');
        setDatalayerGTM("GTM_DEPOSIT_ERROR",{"gtmError":errorElement.innerHTML})
    }
}

function createStripeCardForm(stripe){
    var elements = stripe.elements();
    var style = {
        base: {
            iconColor: '#666EE8',
            color: '#31325F',
            fontSize: '13px',
            '::placeholder': {
                color: '#999'
            }
        }
    };

    window.__stripeCardNumberElement = elements.create('cardNumber', {
        style: style
    });
    window.__stripeCardNumberElement.mount('#card-number-element');

    var cardExpiryElement = elements.create('cardExpiry', {
        style: style
    });
    cardExpiryElement.mount('#card-expiry-element');

    var cardCvcElement = elements.create('cardCvc', {
        style: style
    });
    cardCvcElement.mount('#card-cvc-element');

    window.__stripeCardNumberElement.on('change', onStripeFormOutcome);
}

function attachCustomerToPaymentIntents(pi_id, cus_email) {
    if(window.is_live){
        return $.get('https://blackbox.tiptoque.com/payments/stripe/attach_cus_to_pi?token=1234&pi_id=' + pi_id + '&email=' + encodeURIComponent(cus_email))
    }else{
       return $.get(URL_BLACKBOX+'/payments/stripe/attach_cus_to_pi?token=1234&pi_id=' + pi_id + '&email=' + encodeURIComponent(cus_email))
    }
}

function instantiateStripeCardForm(stripe, token) {
    __log('Création du formulaire de carte');
    var $d = $.Deferred();

    //  $('#stripeModal').modal('show').on('hidden.bs.modal', $d.reject);

    $('#stripeModal').css({display: 'flex'});
    $('body').off('click.modalBackground').on('click.modalBackground', '#stripeModal', function (e) {
        if($(e.originalEvent.originalTarget).is('#stripeModal')) {
            $('#stripeModal').hide();
        }
    }).off('click.modalBackgroundClose').on('click.modalBackgroundClose', '#stripeModal [data-dismiss="modal"]', function (e) {
        $('#stripeModal').hide();
    })

    function onStripeFormSubmit(e) {
        __log('Formulaire de carte envoyé')

        e.preventDefault();
        $(this).find('button').addClass('disabled');
        var email = $('#order-email-element').val();
        attachCustomerToPaymentIntents(localStorage.getItem('tt_pisecrets').split('_secret_')[0], email)
            .then(function(res) {
                stripe.confirmCardPayment(token, {
                    payment_method: {
                        card: window.__stripeCardNumberElement,
                        type: 'card',
                        billing_details: {
                            name: $('#order-name-element').val() + ' (' + email + ')'
                        }
                    }
                })
                    .then(function(result) {
                        __log('Résultat de la caution', result, JSON.stringify(result))
                        if (result.error) {
                            $('#payment-form').find('button').removeClass('disabled');
                            // Show error to your customer (e.g., insufficient funds)
                            var msgError =  'Oups, il y a un malentendu entre notre cocotte et votre carte.<br/>Utilisez <a style="color: #d32d31; text-decoration: underline" href="' + window.stripeTypeformURL + '" target="_blank">ce formulaire</a> pour nous aider à trouver une solution.<br/>Signé le Gang.'
                            $('#card-errors').html(msgError)

                            setDatalayerGTM("GTM_DEPOSIT_ERROR",{"gtmError":msgError})

                        } else {
                            // Send cus, pm et email to hook
                            $.post('https://hooks.zapier.com/hooks/catch/2866807/ojv7lta/', {
                                email: email,
                                cus: res.cus.id,
                                pm: result.paymentIntent.payment_method,
                                test: !window.is_stripe_live
                            }, function (res2) {
                                CartJS.setAttribute('stripe_deposit', result.paymentIntent.payment_method, {
                                    success: $d.resolve
                                });
                            });

                        }
                    });
            });
    }
    $('#payment-form').off('submit').on('submit', onStripeFormSubmit);
    return $d;
}

function checkStripeDeposit() {
    var $d = $.Deferred();
    CartJS.getCart({
        success: function() {
            var needDeposit = false;
            for(var i = 0; i < CartJS.cart.items.length; i++) {
                var item = CartJS.cart.items[i];
                if(item.product_type ==="Livraison"){
                    continue;
                }
                if(!!item.properties._deposit && item.properties._deposit==="true") {
                    needDeposit = true;
                }
            }
            if(needDeposit) {
                $(document).trigger('STRIPE.needDeposit');
                __log('La commande nécessite une caution')
                instantiateStripeDeposit().then($d.resolve, $d.reject);
            } else {
                $(document).trigger('STRIPE.notNeedDeposit');
                __log('La commande ne nécessite pas de caution')
                $d.resolve();
            }
        }
    });
    return $d;
}

(function() {
    window.is_live = !key_stripe.includes("test")
    window.__stripe_instance = Stripe(key_stripe);
    createStripeCardForm(__stripe_instance);
})()